export default {
  SET_TAGS(state, tags) {
    state.tags = tags
  },
  REMOVE_TAG(state, itemId) {
      const tagIndex = state.tags.datas.findIndex((u) => u.id == itemId)
      state.tags.datas.splice(tagIndex, 1)
  },
  SELECTED_TAG(state,data){
    state.tags.datas = []
    state.tags.total = 1;
    state.tags.per_page = 1;
    state.tags.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.tag = data
  },
  ADD_ITEM(state,data){
    state.tag = data
  },
}
